import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { aToolbar } from "./toolbar";
import CookieService from "./services/cookie.service";
import { agentService, getCustomerInfo } from "./services/agent.service";
import WSocketService from "./services/websocket.service";
import parsePhoneNumberFromString from 'libphonenumber-js'
import HttpService from '../src/services/http.service';
import { countryCodes } from "./constants";
import { app } from "./config";
import moment from "moment";
import { showErrorNotification, showSuccessNotification, showWarningNotification } from "./components/common/NotiService";
import { store } from "./context/store";
import { manualDial } from "./services/webEventHandlers";
import LocalStorageService from "./services/localstorage.service";
import { setLoginViaAppData } from "./context/toolbarSlice";
import { handleAgentLogin } from "./services/authService";
import Logger from "./services/logger.service";

export default function ToolbarMixin() {

    const dispatch = useDispatch();
    const toolbar = useSelector(state => state.toolbar);
    const call = useSelector(state => state.call);
    const answeredChats = useSelector((state) => state.digital.answeredChats);
    const unansweredChats = useSelector((state) => state.digital.unansweredChats);

    useEffect(() => {
        if (window.parent) {
            console.log("window.parent");
            window.parent.postMessage({ cmd: "plugin" }, "*");
        }
    }, [])

    useEffect(() => {
        window.aToolbar = aToolbar;
        window.toolbarMixin = {
            agentLoginDetails: toolbar.loginDetails,
            callDetails: call.callDetails,
            setCookie: (cname, cvalue, exdays) => CookieService.setCookie(cname, cvalue, exdays),
            agentService: (reqType, data) => agentService(reqType, data),
            getCustomerInfo: (data) => getCustomerInfo(data),
            WSocketService: WSocketService,
            parsePhoneNumberFromString: parsePhoneNumberFromString,
            HttpService: HttpService,
            countryCodes: countryCodes,
            agentState: toolbar.agent.state,
            agentMode: toolbar.agent.mode,
            isCallActivityPresent: call.isCallActivityPresent,
            isLoggedIn: toolbar.isLoggedIn,
            blendedModeActiveDialer: toolbar.blendedModeActiveDialer,
            onCtiSettings: (settingsData) => {
                try {
                    if (toolbar.isLoggedIn) {
                        Logger.log("Agent already logged in, skipping auto-login from CTI settings");
                        return;
                    }

                    if (settingsData?.source === "dynamics365-agent-info") {
                        try {
                            const userInfo = settingsData?.payload?.userInfo || settingsData?.userInfo || {};
                            let loginData = {
                                customer: userInfo?.accountname || '',
                                agentid: userInfo?.agentId || '',
                                apiKey: userInfo?.password || '',
                                sip: (userInfo?.sip === "true" || userInfo?.sip === true) 
                            }
                            if (loginData.sip === false || loginData.sip === "false") {
                                if (!userInfo?.phoneNumber) {
                                    showWarningNotification("Phone Number is required, please check if phone number is added.");
                                    Logger.warn("Salesforce CTI auto-login: Missing phoneNumber (userInfo.phoneNumber)");
                                    return;
                                }
                                loginData.phoneNumber = userInfo?.phoneNumber;
                            }
                            dispatch(setLoginViaAppData({ ...loginData }));
                            // Trigger agent login (clone to avoid mutation issues in agentLogin service)
                            handleAgentLogin({ ...loginData }, () => true).then((resp) => {
                                if (resp === "Login success") {
                                    CookieService.setCookie("agentName", userInfo?.agentId, { expires: 7, samesite: "None", secure: true });
                                    CookieService.setCookie("sso_data", loginData, { expires: 7, samesite: "None", secure: true });
                                }
                            });
                            return;
                        } catch (error) {
                            Logger.error("Salesforce CTI auto-login failed", error);
                        }
                        return;
                    }

                    const callCenterSettings = settingsData?.payload?.callCenterSettings || settingsData?.callCenterSettings || settingsData;
                    const userInfo = settingsData?.payload?.userInfo || settingsData?.userInfo || {};
                    const account = callCenterSettings["/reqPhoneDemoSettings/reqProviderAccount"];
                    const apiKey = callCenterSettings["/reqPhoneDemoSettings/reqProviderAuthToken"];
                    let agentId = '';
                    if (typeof userInfo.runApex === "string") {
                        try {
                            const runApexObj = JSON.parse(userInfo.runApex);
                            agentId = runApexObj?.username || '';
                        } catch (e) {
                            Logger.warn("Salesforce CTI auto-login: Failed to parse runApex userInfo", e);
                        }
                    }

                    if (!account) {
                        Logger.warn("Salesforce CTI auto-login: Missing account (/reqPhoneDemoSettings/reqProvider)");
                        return;
                    }
                    if (!apiKey) {
                        Logger.warn("Salesforce CTI auto-login: Missing apiKey (/reqPhoneDemoSettings/reqProviderAuthToken)");
                        return;
                    }
                    if (!agentId) {
                        Logger.warn("Salesforce CTI auto-login: Missing agentId (userInfo.username)");
                        return;
                    }

                    const loginData = Object.assign({}, {
                        customer: account,
                        agentid: agentId,
                        apiKey: apiKey,
                        sip: true
                    });

                    Logger.info("Salesforce CTI auto-login: Initiating login for agent " + agentId + " (SIP)");
                    // Dispatch login data to store (clone to avoid mutation issues)
                    dispatch(setLoginViaAppData({ ...loginData }));
                    // Trigger agent login (clone to avoid mutation issues in agentLogin service)
                    handleAgentLogin({ ...loginData }, () => true);
                } catch (error) {
                    Logger.error("Salesforce CTI auto-login failed");
                }
            },
            manualDial: (number) => manualDial(store.getState().toolbar.agent.mode, null, number, LocalStorageService.getItem("selectedCampaign"), null, null, null, true),
            toolbarInstance: app.toolbarInstance,
            moment: moment,
            showWarningNotificationforMode: () => showWarningNotification("Please Change Your Mode To Manual Or Manual In Blended Mode"),
            showWarningNotificationforState: () => showWarningNotification("Please Change Your State To Ready"),
            showWarningNotificationforCampaign: () => showWarningNotification("Choose a campaign"),
            showWarningNotificationforNumber: () => showWarningNotification("PhoneNumber is Not Valid"),
            showWarningNotificationforCallActivityAlreadyPresent: () => showWarningNotification("You Are alredy in a call Please finish this call and try again"),
            showWarningNotificationforLoggingIn: () => showWarningNotification("You have not logged In to AgentToolbar yet"),
            showSuccessNotificationforFreshservice: (msg) => showSuccessNotification(msg),
            showDangerNotificationforFreshservice: (msg) => showErrorNotification(msg),
            observable: {
                trigger: (name, data) => {
                }
            }
        };
    }, [toolbar, call, aToolbar])

    return (
        <></>
    );
};